import { Fade } from '../common'
import { ApprovedReshipmentItem } from '.'
import { fetchApprovedReshipments } from '../../actions/reshipment'
import {
  getReshipmentSummaryStatusProps,
  getReshipmentSummaryData,
  getApprovedReshipmentsStatusProps,
  getApprovedReshipmentsData,
} from '../../selectors/reshipment'

const mapStateToProps = state => {
  const { orgId } = getReshipmentSummaryData(state)
  const { fetched: summaryFetched } = getReshipmentSummaryStatusProps(state)
  const { fetching, error } = getApprovedReshipmentsStatusProps(state)
  const { data: approvedReshipments } = getApprovedReshipmentsData(state)
  const noItems = approvedReshipments.length === 0
  return {
    summaryFetched,
    orgId,
    approvedReshipments,
    noItems,
    fetching,
    error,
  }
}

export default connect(mapStateToProps, { fetchApprovedReshipments })(
  ({ summaryFetched, orgId, approvedReshipments, noItems, error, fetchApprovedReshipments }) => {
    useEffect(() => {
      if (summaryFetched && orgId) {
        fetchApprovedReshipments(orgId)
      }
    }, [summaryFetched, orgId])

    if (error) {
      return <p className="cb-error-msg">Error retreiving Reshipments History</p>
    }

    if (noItems) {
      return null
    }

    return (
      <Fade>
        <div>
          <h3 style={{ marginTop: '24px', marginBottom: '12px' }}>Reshipment History</h3>
          {approvedReshipments.map(item => (
            <ApprovedReshipmentItem key={item.name.replace(' ', '_')} item={item} />
          ))}
        </div>
      </Fade>
    )
  }
)
